import React from 'react';
import {ISearchFilter, ISearchFilterOption} from '../../../../../context/search/types';
import useSearch from '../../../../../context/search/useSearch';

interface IMultiOptionFilter {
  filterIndex: number,
  filter: ISearchFilter,
}

const MultiOptionFilter: React.FC<IMultiOptionFilter> = ({filterIndex, filter}): JSX.Element => {

  const {inputEventHandlers} = useSearch()

  const renderLabel = (option: ISearchFilterOption): string => {
    if (option.records !== null) {
      return `${option.label} (${option.records})`
    }
    return option.label
  }

  return (
    <React.Fragment>
      <div className={'sf-search-filter-options sf-search-filter-multi-options'}>
        {
          (filter.options as ISearchFilterOption[]).map((option, index) => {
            const disabled = option.records < 1 && !option.selected;
            return (
              <React.Fragment key={index}>
                <label className={`sf-search-filter-option sf-search-filter-multi-option  ${option.selected ? 'is-selected' : ''} ${disabled ? 'is-disabled' : ''}` }>
                  <span className={'sf-search-filter-multi-option-label'}>{renderLabel(option)}</span>
                  <input onChange={() => inputEventHandlers.handleToggleMultiOption(filterIndex, index)} checked={option.selected} className="visually-hidden" disabled={disabled} type="checkbox"  />
                </label>
              </React.Fragment>
            )
          })}
      </div>
    </React.Fragment>
  )
}

export default MultiOptionFilter